import { hotTopics } from "@/mocks/data";

export default function HotTopics() {
  return (
    <section id="hot" className="bg-background-100/70 py-14 md:py-20">
      <div className="mx-auto w-full max-w-7xl px-4 md:px-6">
        <div className="flex flex-col gap-4 md:flex-row md:items-end md:justify-between">
          <div>
            <div className="mb-3 flex items-center gap-2 text-sm font-medium text-primary-600">
              <i className="ri-fire-line text-lg"></i>
              今日热瓜榜
            </div>
            <h2 className="font-heading text-2xl text-foreground-950 md:text-4xl">
              此刻正在被热议的瓜
            </h2>
            <p className="mt-3 max-w-xl text-sm text-foreground-600 md:text-base">
              热度实时刷新,按讨论量与蹲守人数排序,通勤速览与睡前必看都会从这里取材。
            </p>
          </div>
          <div className="flex items-center gap-2 rounded-full bg-background-50 px-4 py-2 text-xs text-foreground-500 ring-1 ring-background-200">
            <span className="flex h-2 w-2 animate-pulse rounded-full bg-accent-500"></span>
            每 10 分钟自动刷新
          </div>
        </div>

        <div className="mt-10 grid grid-cols-1 gap-4 lg:grid-cols-2">
          {hotTopics.map((t) => (
            <article
              key={t.id}
              className="group flex gap-4 rounded-2xl bg-background-50 p-4 transition-colors hover:bg-background-50 md:gap-5 md:p-5"
            >
              <div className="flex flex-col items-center">
                <span
                  className={`font-heading text-2xl md:text-3xl ${
                    t.rank <= 3 ? "text-primary-500" : "text-background-300"
                  }`}
                >
                  {String(t.rank).padStart(2, "0")}
                </span>
                <div className="mt-auto flex flex-col items-center gap-1">
                  {t.trend === "up" && (
                    <i className="ri-arrow-up-line text-accent-500" aria-hidden="true"></i>
                  )}
                  {t.trend === "down" && (
                    <i className="ri-arrow-down-line text-background-300" aria-hidden="true"></i>
                  )}
                  {t.trend === "new" && (
                    <span className="rounded-full bg-accent-500 px-1.5 py-0.5 text-[10px] font-bold text-background-50">
                      新
                    </span>
                  )}
                </div>
              </div>

              <div className="flex-1">
                <div className="mb-2 flex flex-wrap items-center gap-2">
                  <span className="rounded-md bg-secondary-100 px-2 py-0.5 text-xs text-secondary-700">
                    {t.tag}
                  </span>
                  <span className="text-xs text-foreground-400">{t.delta} 人在蹲</span>
                </div>
                <h3 className="text-sm font-semibold leading-snug text-foreground-900 md:text-base">
                  {t.title}
                </h3>
                <p className="mt-2 hidden text-xs leading-relaxed text-foreground-500 sm:block">
                  {t.summary}
                </p>
                <div className="mt-3 flex items-center gap-2">
                  <span className="text-xs text-foreground-400">热度</span>
                  <div className="h-1.5 flex-1 overflow-hidden rounded-full bg-background-200">
                    <div
                      className="h-full rounded-full bg-gradient-to-r from-primary-400 to-primary-600"
                      style={{ width: `${t.heat}%` }}
                    ></div>
                  </div>
                  <span className="font-heading text-sm text-primary-600">{t.heat}</span>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}